import { useLocation } from 'react-router-dom';
import { type IProduct } from '@entities/product';
import { PageHelmet } from '@widgets/seoPage';
import { Helmet } from 'react-helmet-async';
import { ComponentProps } from 'react';

export function SingleProductHelmet({
  product: { title, text_id, weight, price, images = [], composition = [] },
  mainDomain,
  currency,
  ...props
}: {
  product: IProduct;
  currency: string;
} & Omit<ComponentProps<typeof PageHelmet>, 'title'>) {
  const { pathname } = useLocation();
  const seoCompos = composition.map((el) => el.title).join(',');
  const path = images[0] && images[0].filename;
  const image = new URL(`/img/${path}`, `https://${mainDomain}`).toString();
  const url = new URL(pathname, `https://${mainDomain}`).toString();
  const seoScript = {
    '@context': 'http://schema.org/',
    '@type': 'Product',
    description: seoCompos,
    name: title,
    alternateName: text_id,
    image,
    weight: {
      '@type': 'QuantitativeValue',
      value: weight, // вес
    },
    offers: {
      '@type': 'Offer',
      availability: 'http://schema.org/InStock',
      url,
      price,
      priceCurrency: currency,
    },
  };

  return (
    <>
      <PageHelmet
        title={title}
        type="object"
        image={image}
        ogTitle={title}
        ogDescription={seoCompos}
        mainDomain={mainDomain}
        {...props}
      />
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(seoScript)}</script>
      </Helmet>
    </>
  );
}
